import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class StartLight extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.workingWidth = 0;
    this.workingHeight = 0;
    this.count = 0;
    this.lightCovers = [];
    const coverLocs = [{ x: 12,y: 13 },{ x: 76,y: 13 },{ x: 142,y: 13 }];

    this.lightContainer = this.scene.add.container();
    this.add(this.lightContainer);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'StartLight', this.lightContainer).setOrigin(0, 0);
    this.workingWidth = this.bg.getBounds().width;
    this.workingHeight = this.bg.getBounds().height;

    let item = null;
    for (let i = 0; i < 3; i++) {
      item = ABCyaPhaser.Images.addImage(0, 0, 'LightOff', this.lightContainer).setOrigin(0, 0);
      item.x = coverLocs[i].x;
      item.y = coverLocs[i].y;
      item.alpha = 0.8;
      this.lightCovers.push(item);
    }

    this.countLabel = ABCyaPhaser.Images.addImage(0, 0, 'Ready3', this).setVisible(false);
  }

  doCountdown() {
    this.countLabel.x = this.workingWidth / 2;
    this.countLabel.y = this.workingHeight + 80;
    this.countLabel.scale = 0;
    this.countLabel.alpha = 0;

    this.countLabel.setVisible(true);

    this.scene.time.delayedCall(500, () => {this.countdown();});
  };

  countdown() {
    this.count++;

    if (this.count === 4) {
      this.showGo();
    }
    else if (this.count > 3) {

    }
    else {
      ABCyaPhaser.Audio.playOneShot('countdown_low', this.scene);

      this.scene.tweens.killTweensOf(this.lightCovers[this.count - 1]);
      this.scene.tweens.killTweensOf(this.lightCovers[this.count - 2]);
      this.scene.tweens.killTweensOf(this.countLabel);

      ABCyaPhaser.Tweens.addTween(this.lightCovers[this.count - 1], 120, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);

      if (this.count > 1) {
        ABCyaPhaser.Tweens.addTween(this.lightCovers[this.count - 2], 200, { alpha: .8 }, Phaser.Math.Easing.Linear);
      }

      this.countLabel.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, `Ready${this.count}`);
      this.countLabel.scale = 0;
      this.countLabel.alpha = 0;

      ABCyaPhaser.Tweens.addTween(this.countLabel, 140, { scale: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
        ABCyaPhaser.Tweens.addTween(this.countLabel, 380, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.scene.time.delayedCall(150, () => {this.fadeReady();});
        });
      });
    }
  };

  fadeReady() {
    ABCyaPhaser.Tweens.addTween(this.countLabel, 500, { scale: 1.4, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.countdown();
    });
  };

  showGo() {
    this.emit('GO_START');

    ABCyaPhaser.Audio.playOneShot('countdown_final', this.scene);

    this.countLabel.setTexture(ABCyaPhaser.Images.LOCALIZATION_ATLAS, 'Go');

    this.scene.tweens.killTweensOf(this.countLabel);
    this.scene.tweens.killTweensOf(this.lightContainer);

    ABCyaPhaser.Tweens.addTween(this.countLabel, 240, { scale: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.countLabel, 800, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        ABCyaPhaser.Tweens.addTween(this.countLabel, 800, { delay: 440, scale: 1.6, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.startFinished();
        });
      });
    });

    ABCyaPhaser.Tweens.addTween(this.lightContainer, 800, { y: this.scene.mid.y * 2 + 200 }, Phaser.Math.Easing.Quadratic.Out);
  };

  startFinished() {
    this.emit('GO_FINISHED');
  };
}